import { PageProps } from 'gatsby'
import React from 'react'

const OnboardingLayout: React.FC<PageProps> = props => {
  return <>{props.children}</>
}

export default OnboardingLayout
